import { createAction, createAsyncAction } from 'typesafe-actions';
import { JsonCalendarItem } from './types';

export const fetchCalendarItems = createAsyncAction(
  'calendar/FETCH_REQUEST',
  'calendar/FETCH_SUCCESS',
  'calendar/FETCH_FAILURE'
)<void, JsonCalendarItem[], Error>();

export const updateCalendar = createAction('calendar/UPDATE_CALENDAR', resolve =>
  () => resolve()
);
